const cn = {
    html: {
        title: '《剑与远征》限时福利-任意充值领限定头像框',
        description: '《剑与远征》Lilith Store专属福利来袭！前往Lilith Store，完成任意一笔《剑与远征》充值，即可免费领取限定永久头像框【鎏金翎冠】！机不可失失不再来，快来领取你的专属福利吧！',
        Keywords: '剑与远征,剑与远征 ios,剑与远征 安卓,剑与远征 官网,莉莉丝,AFK Arena,剑与远征充值,Lilith, Lilith Games,Lilith Store,PlutoMall'
    },

    rule: {
        title: '活动规则',
        detial: `
            <p>1、活动时间:2024年9月1日0:00(UTC+0)起限时上线</p>
            <p>2、如何参与:2024年9月1日起,在Lilith Store完成任意一笔消费,即可获得专属道具奖励</p>
            <p>3、奖励下发:在本页面成功领取后,奖励将下发到您游戏内邮箱中,请注意查收</p>
            <p>4、活动奖励:《剑与远征》限定头像框"鎏金翎冠"(获得后永久有效)</p>
            <p>5、活动须知:</p>
            <p>(1)如果玩家在领取道具后退款,我们有权回收已下发的道具奖励</p>
            <p>（2）页面充值数据存在一定延迟，若您已完成，可选择手动刷新页面数据。 请您依照活动规则及时进行活动参与及奖励领取，若非因主办方原因导致您未成功参与活动、兑换或领取奖品导致发奖失败，则视为放弃参与活动或放弃领奖，全部损失由您自行承担，主办方不会给予任何形式的补偿。</p>
            <p>（3）在参与本活动过程中，玩家如果出现违规行为（包括但不限于作弊领取、恶意套取等），主办方将取消该玩家参与本活动的资格，并有权撤销违规获得的福利并保留追究其法律责任的权利。</p>
            <p>（4）您参与本活动所主动填写的或由主办方收集的账号昵称、帐号UID、联系方式（包括但不限于电话号码等）及其他个人信息属于您自愿提供用来实现参与本活动之目的，主要用于活动身份确认、未成年人充值限制、奖励发放、个税缴纳（主办方或其委托的第三方将依法履行相关税费代扣代缴的义务），您有权拒绝提供，但可能无法正常参与本活动，如您查询、修改、删除、撤回授权提交的个人信息的，或对个人信息保护有任何疑问或投诉，可以与主办方联系，我们将尽快配合处理。主办方承诺将对您提交的信息中所有涉及个人隐私的内容予以保密，但可能会为宣传推广比赛及营销活动等目的使用您的网络平台昵称、手机号码（我们会对号码进行部分遮挡处理）、头像等个人信息，包括但不限于在官方网站公示获奖者名单、对媒体披露获奖者的信息等行为。</p>
            <p>（5）您知悉互联网存在诸多不确定性因素，因此理解并同意，如因不可抗力、网络、通讯线路故障、计算机大规模瘫痪及活动中存在大面积作弊行为等非主办方原因致使本活动出现异常情况或难以继续开展的，主办方有权采取包括但不限于通过各种方式消除异常情况或调整、暂停、取消本活动等措施，因此造成损失的，主办方不承担任何责任。</p>
            <p>（6）在法律法规允许的范围内，主办方有权对本活动说明及其他规则进行变动或调整，相关变动或调整将公布在活动页面或主办方官方社交媒体账号上，并于公布时即时生效。如您对修改后的活动说明及其他规则有异议的，请立即停止参加活动，如继续参加本活动，则视为您同意本活动说明及其他规则的修改。</p>
            <p>（7）本活动由 LILITH GAMES 主办，如有疑问请联系afkarena-service@lilithgames.com，本活动与苹果公司无关。</p>
        `,
    },

    // 登录
    login: {
        login: "点击登录",
        logout: "退出登录",
        changeRole: "切换角色",
    },

    // 角色
    role: {
        title: "选择登录角色",
        label1: "角色昵称",
        label2: "服务器",
    },

    // 头像框
    header: {
        timeTxt: "9月1日0:00(UTC+0)起，在Lilith Store完成任意一笔《剑与远征》充值，即可领取限定头像框奖励！",
        txt: "限定头像框:鎏金翎冠",
        toPay: "去充值",
        toSubmit: "立即领取",
        submitEnd: "已领取"
    },
    // 系统提示
    sys: {
        200: "限定头像框奖励领取成功！请前往游戏内邮箱查看。",
        405: "系统繁忙,请稍后再试，或联系客服!"
    },

    btnOk: "确定",
    
    toast:'未获取到角色信息',
    awaitTxt:'完成支付后，需要耐心等待几分钟，刷新页面才能领取奖励'
}
// 导出
export default cn;
